exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SelectPortal_FormTitle_1Tlg2 {\n    color: blue;\n    margin: auto;\n    align-items: left;\n    padding-left: 10px;\n    display: flex;\n    flex-flow: row;\n    justify-content: left;\n    font-size: 18px;\n    font-weight: bolder;\n    margin: 10px 0px 0 20px;\n}\n\n.SelectPortal_Message_1is8g {\n    padding-left: 20px;\n}", ""]);

// Exports
exports.locals = {
	"FormTitle": "SelectPortal_FormTitle_1Tlg2",
	"Message": "SelectPortal_Message_1is8g"
};